import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum bulkCustomersType {
    UPLOAD_BULK_CUSTOMERS = "@@auth/UPLOAD_BULK_CUSTOMERS",
    UPLOAD_BULK_CUSTOMERS_SUCCESS = "@@auth/UPLOAD_BULK_CUSTOMERS_SUCCESS",
    UPLOAD_BULK_CUSTOMERS_ERROR = "@@auth/UPLOAD_BULK_CUSTOMERS_ERROR",
    RESET_UPLOAD_BULK_CUSTOMERS = "@@auth/RESET_UPLOAD_BULK_CUSTOMERS",

    FETCH_BULK_CUSTOMERS = "@@auth/FETCH_BULK_CUSTOMERS",
    FETCH_BULK_CUSTOMERS_SUCCESS = "@@auth/FETCH_BULK_CUSTOMERS_SUCCESS",
    FETCH_BULK_CUSTOMERS_ERROR = "@@auth/FETCH_BULK_CUSTOMERS_ERROR",
    RESET_FETCH_BULK_CUSTOMERS = "@@auth/RESET_FETCH_BULK_CUSTOMERS",

    FETCH_BULK_CUSTOMERS_DETAIL = "@@auth/FETCH_BULK_CUSTOMERS_DETAIL",
    FETCH_BULK_CUSTOMERS_DETAIL_SUCCESS = "@@auth/FETCH_BULK_CUSTOMERS_DETAIL_SUCCESS",
    FETCH_BULK_CUSTOMERS_DETAIL_ERROR = "@@auth/FETCH_BULK_CUSTOMERS_DETAIL_ERROR",
    RESET_FETCH_BULK_CUSTOMERS_DETAIL = "@@auth/RESET_FETCH_BULK_CUSTOMERS_DETAIL",

    BULK_CUSTOMERS_VERSION = "@@auth/BULK_CUSTOMERS_VERSION",
    BULK_CUSTOMERS_VERSION_SUCCESS = "@@auth/BULK_CUSTOMERS_VERSION_SUCCESS",
    BULK_CUSTOMERS_VERSION_ERROR = "@@auth/BULK_CUSTOMERS_VERSION_ERROR",
    RESET_BULK_CUSTOMERS_VERSION = "@@auth/RESET_BULK_CUSTOMERS_VERSION",

    BULK_CUSTOMERS_PUBLISH = "@@auth/BULK_CUSTOMERS_PUBLISH",
    BULK_CUSTOMERS_PUBLISH_SUCCESS = "@@auth/BULK_CUSTOMERS_PUBLISH_SUCCESS",
    BULK_CUSTOMERS_PUBLISH_ERROR = "@@auth/BULK_CUSTOMERS_PUBLISH_ERROR",
    RESET_BULK_CUSTOMERS_PUBLISH = "@@auth/RESET_BULK_CUSTOMERS_PUBLISH",

    BULK_CUSTOMERS_FILE_DOWNLOAD = "@@auth/BULK_CUSTOMERS_FILE_DOWNLOAD",
    BULK_CUSTOMERS_FILE_DOWNLOAD_SUCCESS = "@@auth/BULK_CUSTOMERS_FILE_DOWNLOAD_SUCCESS",
    BULK_CUSTOMERS_FILE_DOWNLOAD_ERROR = "@@auth/BULK_CUSTOMERS_FILE_DOWNLOAD_ERROR",
    RESET_BULK_CUSTOMERS_FILE_DOWNLOAD = "@@auth/RESET_BULK_CUSTOMERS_FILE_DOWNLOAD",

    FETCH_BULK_FILE_SPECIFIC_CUSTOMERS = "@@auth/FETCH_BULK_FILE_SPECIFIC_CUSTOMERS",
    FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_SUCCESS = "@@auth/FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_SUCCESS",
    FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_ERROR = "@@auth/FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_ERROR",
    RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMERS = "@@auth/RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMERS",

    APPROVE_BULK_CUSTOMERS_FILE = "@@auth/APPROVE_BULK_CUSTOMERS_FILE",
    APPROVE_BULK_CUSTOMERS_FILE_SUCCESS = "@@auth/APPROVE_BULK_CUSTOMERS_FILE_SUCCESS",
    APPROVE_BULK_CUSTOMERS_FILE_ERROR = "@@auth/APPROVE_BULK_CUSTOMERS_FILE_ERROR",
    RESET_APPROVE_BULK_CUSTOMERS_FILE = "@@auth/RESET_APPROVE_BULK_CUSTOMERS_FILE",

    REJECT_BULK_CUSTOMERS_FILE = "@@auth/REJECT_BULK_CUSTOMERS_FILE",
    REJECT_BULK_CUSTOMERS_FILE_SUCCESS = "@@auth/REJECT_BULK_CUSTOMERS_FILE_SUCCESS",
    REJECT_BULK_CUSTOMERS_FILE_ERROR = "@@auth/REJECT_BULK_CUSTOMERS_FILE_ERROR",
    RESET_REJECT_BULK_CUSTOMERS_FILE = "@@auth/RESET_REJECT_BULK_CUSTOMERS_FILE",

    DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK = "@@auth/DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK",
    DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_SUCCESS = "@@auth/DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_SUCCESS",
    DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_ERROR = "@@auth/DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_ERROR",
    RESET_DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK = "@@auth/RESET_DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK",

    DELETE_BULK_CUSTOMERS_FILE = "@@auth/DELETE_BULK_CUSTOMERS_FILE",
    DELETE_BULK_CUSTOMERS_FILE_SUCCESS = "@@auth/DELETE_BULK_CUSTOMERS_FILE_SUCCESS",
    DELETE_BULK_CUSTOMERS_FILE_ERROR = "@@auth/DELETE_BULK_CUSTOMERS_FILE_ERROR",
    RESET_DELETE_BULK_CUSTOMERS_FILE = "@@auth/RESET_DELETE_BULK_CUSTOMERS_FILE",

}

// Action Types
export type BulkCustomersAction = {
    type:
    | bulkCustomersType.UPLOAD_BULK_CUSTOMERS
    | bulkCustomersType.RESET_UPLOAD_BULK_CUSTOMERS

    | bulkCustomersType.FETCH_BULK_CUSTOMERS
    | bulkCustomersType.RESET_FETCH_BULK_CUSTOMERS

    | bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL
    | bulkCustomersType.RESET_FETCH_BULK_CUSTOMERS_DETAIL

    | bulkCustomersType.BULK_CUSTOMERS_VERSION
    | bulkCustomersType.RESET_BULK_CUSTOMERS_VERSION

    | bulkCustomersType.BULK_CUSTOMERS_PUBLISH
    | bulkCustomersType.RESET_BULK_CUSTOMERS_PUBLISH

    | bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD
    | bulkCustomersType.RESET_BULK_CUSTOMERS_FILE_DOWNLOAD

    | bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS
    | bulkCustomersType.RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMERS

    | bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE
    | bulkCustomersType.RESET_APPROVE_BULK_CUSTOMERS_FILE

    | bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE
    | bulkCustomersType.RESET_REJECT_BULK_CUSTOMERS_FILE

    | bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK
    | bulkCustomersType.RESET_DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK

    | bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE
    | bulkCustomersType.RESET_DELETE_BULK_CUSTOMERS_FILE


    payload: any;
};

export type uploadBulkCustomersFile = {
    bulkCustomerFile: File;
}

export type BulkCustomersDetail = {
    externalID: string,
    internalID: string
}

export type BulkCustomersVersionType = {
    id: any,
    filter: FilterMetadata
}

export type BulkCustomersFileMakerRemarkType = {
    remarkPayload: { makerRemarks: string },
    externalId: string
}

export type BulkCustomersFileCheckerRemarkType = {
    remarkPayload: { checkerRemarks: string },
    externalId: string
}

export type BulkCustomersDownloadFileType = {
    downloadURL: string
}



// Saga Types
export type uploadBulkCustomersFileSaga = {
    type: string,
    payload: uploadBulkCustomersFile
}

export type fetchBulkCustomersSaga = {
    type: string,
    payload: FilterMetadata
}
export type fetchBulkCustomersDetailSaga = {
    type: string,
    payload: BulkCustomersDetail
}
export type BulkCustomersVersionSaga = {
    type: string,
    payload: BulkCustomersVersionType
}
export type BulkCustomersFileMakerRemarkSaga = {
    type: string,
    payload: BulkCustomersFileMakerRemarkType
}

export type BulkCustomersFileCheckerRemarkSaga = {
    type: string,
    payload: BulkCustomersFileCheckerRemarkType
}

export type BulkCustomersDownloadSaga = {
    type: string,
    payload: BulkCustomersDownloadFileType
}


// Reducer Types
type reducerPayload = {
    data: FetchApiResponse<any>; // Future option: FetchApiResponse<any> | Record<string, unknown>
    error: string;
}

export type BulkCustomersReducer = {
    type:
    | bulkCustomersType.UPLOAD_BULK_CUSTOMERS
    | bulkCustomersType.UPLOAD_BULK_CUSTOMERS_SUCCESS
    | bulkCustomersType.UPLOAD_BULK_CUSTOMERS_ERROR
    | bulkCustomersType.RESET_UPLOAD_BULK_CUSTOMERS

    | bulkCustomersType.FETCH_BULK_CUSTOMERS
    | bulkCustomersType.FETCH_BULK_CUSTOMERS_SUCCESS
    | bulkCustomersType.FETCH_BULK_CUSTOMERS_ERROR
    | bulkCustomersType.RESET_FETCH_BULK_CUSTOMERS

    | bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL
    | bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL_SUCCESS
    | bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL_ERROR
    | bulkCustomersType.RESET_FETCH_BULK_CUSTOMERS_DETAIL

    | bulkCustomersType.BULK_CUSTOMERS_VERSION
    | bulkCustomersType.BULK_CUSTOMERS_VERSION_SUCCESS
    | bulkCustomersType.BULK_CUSTOMERS_VERSION_ERROR
    | bulkCustomersType.RESET_BULK_CUSTOMERS_VERSION

    | bulkCustomersType.BULK_CUSTOMERS_PUBLISH
    | bulkCustomersType.BULK_CUSTOMERS_PUBLISH_SUCCESS
    | bulkCustomersType.BULK_CUSTOMERS_PUBLISH_ERROR
    | bulkCustomersType.RESET_BULK_CUSTOMERS_PUBLISH

    | bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD
    | bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD_SUCCESS
    | bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD_ERROR
    | bulkCustomersType.RESET_BULK_CUSTOMERS_FILE_DOWNLOAD

    | bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS
    | bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_SUCCESS
    | bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_ERROR
    | bulkCustomersType.RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMERS

    | bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE
    | bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE_SUCCESS
    | bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE_ERROR
    | bulkCustomersType.RESET_APPROVE_BULK_CUSTOMERS_FILE

    | bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE
    | bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE_SUCCESS
    | bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE_ERROR
    | bulkCustomersType.RESET_REJECT_BULK_CUSTOMERS_FILE

    | bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK
    | bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_SUCCESS
    | bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_ERROR
    | bulkCustomersType.RESET_DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK

    | bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE
    | bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE_SUCCESS
    | bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE_ERROR
    | bulkCustomersType.RESET_DELETE_BULK_CUSTOMERS_FILE

    payload: reducerPayload;
};

export type BulkCustomersReducerStateWithoutListObject = {
    loading?: boolean;
    data?: CreateApiResponse<any>;
    error?: string | null;
};
export type BulkCustomersReducerStateWithListObject = {
    loading?: boolean;
    data?: FetchApiResponse<any>;
    error?: string | null;
};

